import * as React from 'react'
import { FC } from 'react'
import { Link } from 'gatsby'

import { cls, tagUrlify } from '../../utils/utils'

import { ITagsProps } from './Tags.types'
import * as styles from './Tags.module.scss'

const Tags: FC<ITagsProps> = ({ tags, nowrapTag, className, selectedTag = '', searchQuery = '', root }) => {
  const selected = tags.find((tag) => tagUrlify(tag) === tagUrlify(selectedTag))
  return (
    <div className={cls(styles.tags, nowrapTag && styles.nowrapTag)}>
      {selectedTag && selected ? (
        <Link
          to={searchQuery ? `/${root}/all-items/?search=${searchQuery}` : `/${root}`}
          className={cls('text--label', styles.tag, styles.singleTag, className)}
        >
          #{selected}&nbsp;&#10005;
        </Link>
      ) : (
        tags.map((tag) => (
          <Link to={`/${root}/${tagUrlify(tag)}/?search=${searchQuery}`} key={tag} className={cls('text--label', styles.tag, className)}>
            #{tag}
          </Link>
        ))
      )}
    </div>
  )
}

export default Tags
